import { useState } from "react";

import { MailOutlined } from "@ant-design/icons";
import { Button, Form, Image, Input, message, Typography } from "antd";
import axios from "axios";
import { RiMailSendLine } from "react-icons/ri";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import loginImage from "../../../assets/img/login-image.png";
import resolvedLogo from "../../../assets/img/pickpacknewlogo.svg";

import techPackIcon from "../../../assets/img/TechPack.svg";

const { Title, Text } = Typography;
const currentYear = new Date().getFullYear();

const ForgotPassword = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { data } = await axios.post("/auth/verifyOTP", {
        email: values?.email,
      });

      setLoading(false);

      if (data?.statusCode === 200) {
        message.success(data?.result?.message || "Амжилттай", 5);
        history.push("/verify-email", values);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className="fp-wrapper">
      {/* Left — cover image */}
      <div className="fp-cover">
        <div
          className="fp-cover-bg"
          style={{ backgroundImage: `url(${loginImage})` }}
        />
        <div className="fp-cover-overlay" />
      </div>

      {/* Right — form card */}
      <div className="fp-form-side">
        <div className="fp-form-main">
          <div className="fp-form-card">
            {/* Logo */}
            <div className="fp-logo-wrap">
              <Image
                src={resolvedLogo}
                className="fp-logo"
                alt="logo"
                preview={false}
              />
            </div>

            {/* Heading */}
            <div className="fp-heading">
              <Title level={3} className="fp-title">
                Нууц үг сэргээх
              </Title>
              <Text className="fp-subtitle">
                Та бүртгэлтэй имэйл хаягаа оруулна уу.
              </Text>
            </div>

            {/* Form */}
            <Form
              form={form}
              name="normal_login"
              layout="vertical"
              className="fp-form"
              labelAlign="left"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                name="email"
                label="Имэйл хаяг"
                rules={[
                  {
                    required: true,
                    message: "Имэйл хаягаа оруулна уу!",
                  },
                  {
                    type: "email",
                    message: "Имэйл хаягийн формат буруу байна.",
                  },
                ]}
                hasFeedback
              >
                <Input
                  size="large"
                  prefix={<MailOutlined />}
                  placeholder="Имэйл хаяг"
                  autoComplete="email"
                  inputMode="email"
                />
              </Form.Item>

              <Button
                type="primary"
                size="large"
                className="fp-submit-btn"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                }}
                icon={<RiMailSendLine size={16} />}
                htmlType="submit"
                loading={loading}
                block
              >
                Илгээх
              </Button>

              <div className="fp-back-link">
                <Button
                  type="link"
                  icon={<ArrowLeftOutlined />}
                  onClick={() => history.push("/")}
                  className="fp-back-btn"
                >
                  Нэвтрэх хуудас руу буцах
                </Button>
              </div>
            </Form>

            {/* Footer */}
          </div>
        </div>
        <div className="fp-footer">
          <div className="fp-footer-brand">
            <span className="fp-powered">Powered by</span>
            <Image
              src={techPackIcon}
              preview={false}
              className="fp-techpack-logo"
              alt="TechPack"
            />
          </div>
          <span className="fp-copyright">
            © 2021-{currentYear} Зохиогчийн эрх хамгаалагдсан
          </span>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
